import React from 'react'
import { Box, Button, Typography, useTheme } from '@mui/material'
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import sectionbgImg from '../../../../images/section-bg.jpg'
import leftImg from '../../../../images/home-section-three-left-image-1.webp'
import rightImg from '../../../../images/home-section-three-right-image-1.webp'
import ratingImg from '../../../../images/rating-image-1a.png'
import { CommonHeading, CommonTitle, DesignBtn } from '../../../../layout/Common';
import { Link } from 'react-router-dom';



const ComprehendYourStyle = () => {
    const theme = useTheme();
    const reviewData = [
        {
            color: '#00000040',
            num: '150+',
            name: 'Product',
        },
        {
            color: { xs: '#00000040', xs: 'transparent' },
            num: '250+',
            name: 'Orders',
        },
        {
            color: { xs: '#00000040', xs: 'transparent' },
            num: '1K',
            name: 'Selling',
        },
        {
            color: '#00000040',
            num: '250+',
            name: 'clients',
        },
    ];


    return (
        <>
            <Box sx={{
                backgroundImage: `url(${sectionbgImg})`,
                backgroundPosition: 'center center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                position: 'relative',
                zIndex: '1',
                backgroundAttachment: 'fixed',
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    zIndex: '-1',
                    backgroundColor: '#0000009c',
                    top: '0'
                }
            }}>
                <Grid container >
                    <Grid xs={12} sm={6} lg={3.5}>
                        <Box sx={{ objectFit: 'cover', height: '100%' }}>
                            <img src={"/images/homepage.jpg"} style={{ width: '100%', height: 'auto' }} />
                        </Box>
                    </Grid>
                    <Grid xs={12} sm={6} lg={4.8}>
                        <Box sx={{ padding: { xs: '10px', sm: '16px', md: '30px', lg: '40px' }, height: '94%', display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
                            <Box sx={{ width: { md: '80%', xs: '92%' }, mx: 'auto' }}>
                                <Box sx={{ textAlign: 'start', }}>
                                    <CommonTitle lineHeight={'1.2'} margin={'10px 0 6px 0'} text={'pure feel'} />
                                    <CommonHeading text={'We understand your fabric taste and craft perfect textures'} fontSize={{ xs: '28px', lg: '40px', xl: '50px' }} marginBottom={'30px'} />
                                </Box>
                                <Grid container sx={{ textAlign: 'start' }}>
                                    {
                                        reviewData.map((val) => {
                                            return (
                                                <>
                                                    <Grid xs={6} sm={6} md={6} lg={6}>
                                                        <Box sx={{
                                                            padding: { xs: '25px', sm: '28px', md: '40px', xl: '50px' }, backgroundColor: val.color, textAlign: 'center',
                                                        }}>
                                                            <Typography sx={{
                                                                fontSize: { xs: '28px', md: '50px', xl: '74px' }, fontFamily: '"Jost", sans-serif', color: '#bb9d7b', lineHeight: '0.8',
                                                                transition: 'all 0.6s ease-in-out', cursor: 'default',
                                                                '&:hover': {
                                                                    color: '#fff',

                                                                }
                                                            }}>{val.num}</Typography>
                                                            <Typography sx={{
                                                                fontSize: {
                                                                    xs: '14px', md: '16px', xl: '18px', transition: 'all 0.6s ease-in-out', cursor: 'default', '&:hover': {
                                                                        color: theme.palette.primary.gold,

                                                                    }
                                                                }, fontFamily: '"Jost", sans-serif', color: '#f0f0f0', lineHeight: '1.3', letterSpacing: '3.5px', textTransform: 'uppercase', mt: 2
                                                            }}>{val.name}</Typography>
                                                        </Box>
                                                    </Grid>
                                                </>
                                            )
                                        })
                                    }
                                </Grid>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid xs={12} md={12} lg={3.7} sx={{ display: 'flex', alignItems: 'end' }}>
                        <Box sx={{ display: { lg: 'block', sm: 'flex', xs: 'block' }, alignItems: 'center', justifyContent: 'center' }}>
                            <Grid xs={12} sm={6} lg={12} sx={{
                                px: { xl: 0, xs: 3 }
                            }}>
                                <Typography sx={{
                                    color: '#fff',
                                    fontSize: '16px',
                                    fontFamily: theme.palette.typography.fontFamily1,
                                    mb: { xl: '50px', lg: '42px' },
                                    lineHeight: { md: '1.9', xs: '1.6' }
                                }}>
                                    Finest premium fabric blends ensure lasting comfort and style. Woven with precision to enhance every stitch in modern tailoring. Our textures and patterns inspire timeless elegance. </Typography>
                                <Box sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                }}>
                                    <Grid xs={12} sx={{
                                        display: { md: 'flex', xs: 'block' },
                                        alignItems: 'center !important',
                                        justifyContent: { md: 'start', xs: 'center' },
                                        mb: { md: 8 },
                                        mt: { lg: 0, md: 2 }
                                    }}>
                                        <Grid xs={12} lg={6} xl={5} sx={{
                                            display: 'flex',
                                            justifyContent: { lg: 'start', xs: 'center' },
                                            my: { lg: '0px', md: '10px', xs: '20px' }
                                        }}>
                                            <Link to="/shop">
                                                <DesignBtn text={'shop the sales'} width={'192px'} />
                                            </Link>
                                        </Grid>
                                        <Grid xs={12} lg={6} xl={7} sx={{
                                            display: 'flex',
                                            justifyContent: { xl: 'center', lg: 'end', xs: 'center' },
                                            mb: { md: 0, xs: 2 }
                                        }}>
                                            <img src={ratingImg} width='200px' height='75px' />
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Grid>
                            <Grid xs={12} sm={6} lg={12}>
                                <Box sx={{ objectFit: 'cover' }}>
                                <img src={"/images/homepageright.jpg"} style={{ width: '100%' }} />
                                </Box>
                            </Grid>
                        </Box>
                    </Grid>
              
                </Grid >
            </Box >
        </>
    )
}

export default ComprehendYourStyle